var React = require('react');

function ImproveProductivityIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M45 7H23v2h22V7zM34 59c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22zm0 2c13.255 0 24-10.745 24-24S47.255 13 34 13 10 23.745 10 37s10.745 24 24 24zm0-38a1 1 0 0 1 1 1v12h12a1 1 0 1 1 0 2H33V24a1 1 0 0 1 1-1z","fill":"#5FD800"}));
}

ImproveProductivityIcon.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = ImproveProductivityIcon;

ImproveProductivityIcon.default = ImproveProductivityIcon;
